import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { Categoria, Parametros, Periodo, Result } from '../../shared/interfaces';
import { FormBuilder } from "@angular/forms";
import { freeSet } from "@coreui/icons";
import { isNil } from "lodash-es";
import { ApiService } from "src/app/api/api.service";

@Component({
    selector: 'filtro-categoria',
    templateUrl: './filtro-categoria.component.html',
    styleUrl: './filtro-categoria.component.scss'
})
export class FiltroCategoriaComponent implements OnInit, OnChanges {
    icons = freeSet;
    private _categorias: Categoria[];
    private _periodos: Periodo[] = [];
    @Output() seleccion = new EventEmitter<number>;
    @Output() seleccionPeriodo = new EventEmitter<number>;
    @Output() busqueda = new EventEmitter<string>;
    @Input() filtroPeriodo: boolean = false;
    @Input() seleccionado: number = -1;
    private _periodoSeleccionado = -1;
    form = this.fb.group({
        nominado: this.fb.control('')
    })

    constructor(private fb: FormBuilder, private api: ApiService) {
        this._categorias = [
            {
                id: 1,
                nombre: 'Social',
                imagen: 'assets/img/icon/social.png'
            },
            {
                id: 2,
                nombre: 'Deporte',
                imagen: 'assets/img/icon/deporte.png'
            },
            {
                id: 3,
                nombre: 'Ciencia',
                imagen: 'assets/img/icon/ciencia.png'
            },
            {
                id: 4,
                nombre: 'Empresarial',
                imagen: 'assets/img/icon/empresarial.png'
            },
            {
                id: 5,
                nombre: 'Arte',
                imagen: 'assets/img/icon/arte.png'
            }
        ]
    }

    ngOnInit(): void {
        this.obtenerPeriodos();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['seleccionado']) {
            this._periodoSeleccionado = this.seleccionado;
        }
    }

    async obtenerPeriodos() {
        try {
            const path = 'periodos'
            let params: Parametros[] = [{ param: 'eliminarPeriodoActual', valor: '1' }]
            const response = (await this.api.consulta(path, false, params, {}, 'GET')).data as Result
            this._periodos = response.data
        } catch (e) {
            console.log(e)
        }
    }

    seleccionCategoria(id: number) {

        if (id === this.seleccionado) {
            this.seleccionado = -1;
            this.seleccion.emit(-1);
            return;
        }

        this.seleccionado = id;
        this.seleccion.emit(id);
    }

    seleccionarPeriodo(id: number) {
        if (id === this._periodoSeleccionado) {
            this._periodoSeleccionado = -1;
            this.seleccionPeriodo.emit(-1);
            return;
        }

        this._periodoSeleccionado = id;
        this.seleccionPeriodo.emit(id);
    }

    buscar() {
        if (!isNil(this.form.value.nominado)) {
            this.busqueda.next(this.form.value.nominado);
        }
    }

    get categorias(): Categoria[] {
        return this._categorias;
    }

    get periodos(): Periodo[] {
        return this._periodos;
    }

    get periodoSeleccionado(): number {
        return this._periodoSeleccionado;
    }
}